export default "__VITE_ASSET__3903f04d__$_?url=__"